import { Environment } from 'src/constants/environments'

export const API_URL =
  ENV === Environment.Stage
    ? 'https://webapi-stg.neuralprisma.com'
    : ENV === Environment.Dev
    ? 'https://webapi-stg.neuralprisma.com' // 'http://localhost:5000'
    : 'https://webapi.neuralprisma.com'
